import { DefaultMetricOptions, EntityLinks, Goal } from '@griply/types';

import { isGoalArchived } from '../derived-goal-state';

const derivedMetricIds = [
  DefaultMetricOptions.CompletedTasks,
  DefaultMetricOptions.SubGoalProgress,
  DefaultMetricOptions.CompletedSubGoals,
];

export type IsGoalProgressUpdatableOptions = {
  goals: Goal[];
  links?: EntityLinks;
};

export const isGoalProgressUpdatable = (
  goal: Goal,
  { goals, links }: IsGoalProgressUpdatableOptions,
): boolean =>
  !!goal.metric?.id &&
  !derivedMetricIds.includes(goal.metric.id as DefaultMetricOptions) &&
  !goal.frozenAt &&
  !isGoalArchived(goal, goals, { links });
